export default __webpack_public_path__ + "static/media/5e.19ed9c50.png";